var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.201,
    height: 38.578,
    viewBox: "0 0 31.201 38.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1811",
    "data-name": "Rectangle 1811",
    width: 31.201,
    height: 38.578,
    fill: "rgba(248,225,247,0.5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5201",
    "data-name": "Group 5201",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5200",
    "data-name": "Group 5200",
    transform: "translate(0 -3)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14026",
    "data-name": "Path 14026",
    d: "M15.363,38.577c-.887-.7-1.8-1.374-2.655-2.117a51.231,51.231,0,0,1-7.969-8.591A25.7,25.7,0,0,1,.5,19.413a15.584,15.584,0,1,1,30.3-7.273c.159.706.223,1.433.334,2.15a2.491,2.491,0,0,0,.065.252v2.067c-.116.7-.2,1.41-.352,2.1a23.535,23.535,0,0,1-3.771,8.252,50.189,50.189,0,0,1-8.718,9.6c-.815.708-1.69,1.346-2.538,2.016ZM15.216,1.836A13.741,13.741,0,0,0,2.258,18.87a23.169,23.169,0,0,0,3.657,7.475,51.426,51.426,0,0,0,9.443,9.964c.222.185.34.1.513-.041a56.378,56.378,0,0,0,6.22-5.936,33.4,33.4,0,0,0,5.845-8.641A14.361,14.361,0,0,0,29.152,13.2,13.917,13.917,0,0,0,15.216,1.836",
    transform: "translate(0 0.001)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14027",
    "data-name": "Path 14027",
    d: "M57.514,45.742A11.935,11.935,0,1,1,45.573,33.788,11.959,11.959,0,0,1,57.514,45.742m-6.121.264h4.263a9.914,9.914,0,0,0-5.466-9.242,10.116,10.116,0,0,0-14.715,9.248h4.288v-.436q0-3.5,0-7c0-.763.339-1.111,1.084-1.111q4.742,0,9.485,0a.938.938,0,0,1,1.059,1.059q0,2.64,0,5.28v2.2m-3.673,6.123h1.815v-12.8H41.631V52.137h1.806c0-.887,0-1.752,0-2.616a.935.935,0,0,1,1.046-1.035c.714,0,1.428,0,2.142,0,.754,0,1.093.343,1.095,1.1,0,.84,0,1.681,0,2.542m3.536,1.9H39.862a9.931,9.931,0,0,0,11.395,0M35.719,47.886a9.888,9.888,0,0,0,1.98,4.143.331.331,0,0,0,.215.123c.607.01,1.214.006,1.824.006V47.886Zm15.692,4.273c.575,0,1.122.018,1.666-.011a.664.664,0,0,0,.461-.233A14.575,14.575,0,0,0,54.663,50.1c.336-.7.558-1.447.843-2.21H51.411Zm-5.547-1.813H45.3v1.8h.565Z",
    transform: "translate(-29.986 -30.115)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14028",
    "data-name": "Path 14028",
    d: "M112.456,91.632c0-.2-.011-.407,0-.61a.918.918,0,0,1,.921-.881.9.9,0,0,1,.9.859,13.1,13.1,0,0,1,0,1.334.906.906,0,0,1-.9.863.918.918,0,0,1-.924-.879c-.014-.228,0-.457,0-.686",
    transform: "translate(-100.227 -80.341)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14029",
    "data-name": "Path 14029",
    d: "M134.98,91.659c0-.216-.012-.433,0-.648a.917.917,0,0,1,.929-.872.906.906,0,0,1,.893.868,13.062,13.062,0,0,1,0,1.334.9.9,0,0,1-.906.854.917.917,0,0,1-.913-.85c-.018-.227,0-.457,0-.686h0",
    transform: "translate(-120.302 -80.339)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14030",
    "data-name": "Path 14030",
    d: "M159.276,91.663c0,.229.016.459,0,.686a.912.912,0,0,1-1.819-.011c-.023-.444-.022-.89,0-1.334a.912.912,0,0,1,1.822.011c.015.215,0,.432,0,.648h0",
    transform: "translate(-140.322 -80.34)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14031",
    "data-name": "Path 14031",
    d: "M114.246,136.737c0,.2.008.407,0,.61a.914.914,0,0,1-1.828.009c-.015-.419-.016-.839,0-1.258a.913.913,0,0,1,1.825-.009c.014.215,0,.432,0,.648Z",
    transform: "translate(-100.185 -120.507)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14032",
    "data-name": "Path 14032",
    d: "M134.979,136.728c0-.216-.012-.433,0-.648a.917.917,0,0,1,.926-.876.905.905,0,0,1,.9.864,13.1,13.1,0,0,1,0,1.334.9.9,0,0,1-.9.858.918.918,0,0,1-.919-.884c-.013-.215,0-.432,0-.648",
    transform: "translate(-120.302 -120.506)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14033",
    "data-name": "Path 14033",
    d: "M159.278,136.775c0,.2.012.408,0,.61a.912.912,0,0,1-1.822.012c-.021-.444-.022-.89,0-1.334a.912.912,0,0,1,1.819-.012c.02.24,0,.483,0,.724Z",
    transform: "translate(-140.322 -120.508)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14034",
    "data-name": "Path 14034",
    d: "M69.188,170.53c0,.229.016.459,0,.686a.912.912,0,0,1-1.819-.017c-.022-.444-.022-.89,0-1.334a.912.912,0,0,1,1.822.017c.014.215,0,.432,0,.648h0",
    transform: "translate(-60.028 -150.631)",
    fill: "rgba(248,225,247,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14035",
    "data-name": "Path 14035",
    d: "M204.328,170.551c0,.2.01.407,0,.61a.913.913,0,0,1-1.825.018c-.019-.431-.019-.865,0-1.3a.912.912,0,0,1,1.823-.018c.017.228,0,.457,0,.686h0",
    transform: "translate(-180.474 -150.631)",
    fill: "rgba(248,225,247,0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.6433759a858b014db6ffe4023b57d733.svg";
export { ForwardRef as ReactComponent };